import Promise from "bluebird"
import JsZip from "jszip"
import FileSaver from "file-saver"

const download = url => fetch(url).then(res => res.blob())

const downloadByGroup = (urls, files_per_group = 8) => {
	return Promise.map(
		urls,
		async url => {
			return await download(url)
		},
		{ concurrency: files_per_group }
	)
}

const exportZip = blobs => {
  console.log({blobs})
  const zip = JsZip()
  const currentDate = new Date().getTime()
  const blobType = blob => {
    switch (blob.type) {
      case "image/jpeg": return "jpg"
      case "image/png": return "png"
      case "image/gif": return "gif"
      case "video/mp4": return "mp4"
      case "video/wav": return "wav"
    }
  }
	if(blobs.length > 1) {
    blobs.forEach((blob, i) => {
      zip.file(`post-${i}.${blobType(blob)}`, blob)
    })
    zip.generateAsync({ type: "blob" }).then(zipFile => {
      const fileName = `KIO-${currentDate}.zip`
      return FileSaver.saveAs(zipFile, fileName)
    })
  } else {
    const fileName = `KIO-post-${currentDate}.${blobType(blobs[0])}`
    return FileSaver.saveAs(blobs[0], fileName)
  }
}

const downloadAndZip = urls => downloadByGroup(urls, 8).then(exportZip)

export default downloadAndZip
